import { render, staticRenderFns } from "./chatContent.vue?vue&type=template&id=2b036ad9&scoped=true&"
import script from "./chatContent.vue?vue&type=script&lang=js&"
export * from "./chatContent.vue?vue&type=script&lang=js&"
import style0 from "./chatContent.vue?vue&type=style&index=0&id=2b036ad9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b036ad9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b036ad9')) {
      api.createRecord('2b036ad9', component.options)
    } else {
      api.reload('2b036ad9', component.options)
    }
    module.hot.accept("./chatContent.vue?vue&type=template&id=2b036ad9&scoped=true&", function () {
      api.rerender('2b036ad9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/chatChartSupervise/chatContent.vue"
export default component.exports